import React from 'react'
import PropTypes from 'prop-types'
import { withRouter, Route, Switch } from 'react-router-dom'
import Passport from 'components/client/passport'
import PassportPayment from 'components/public/passport/payment'

const PassportRoute = ({ match }) => (
  <Switch>
    <Route exact path={match.path} component={Passport} />
    <Route path={`${match.path}/pay/:plan/:place`} component={PassportPayment} />
  </Switch>
)

PassportRoute.propTypes = {
  match: PropTypes.object,
}

export default withRouter(PassportRoute)
